// extracted by mini-css-extract-plugin
export default {"AddPropertyPage":"styles_AddPropertyPage__iay-I","container":"styles_container__0Rz-K"};